module.exports = __webpack_public_path__ + "img/t_1.3837d269.png";